import React from "react";
import { useNavigate } from "react-router-dom";
import ready_beer from "../assets/ready_beer.png";
import appDownloadQr from "../assets/app_download_qr.png";

// The QR is a client-supplied image, not generated at runtime: it carries the my HOOM logo in its
// centre, and react-qr-code draws modules only with no way to reserve a clear region for one.
// It decodes to https://www.myhoom.com/app_redirect, which detects iOS vs Android and forwards to
// the right store. Because the URL is inside a binary, a Chromium test in app-download-qr.spec.js
// decodes the rendered pixels to prove it still reaches production.
//
// Rendered at the asset's native 240px: shrinking a QR resamples across module boundaries and the
// thin single-module lines blur away first. The file already carries a 22px white border, which is
// the four-module quiet zone a camera needs; the card padding below is framing on top of that.
const QR_SIZE = 240;
const QR_CARD_PADDING = 16;

function ReadyToSend() {
  const navigate = useNavigate();

  return (
    <section
      style={{
        width: "100%",
        // border-box: this section is width:100% and the 20px of new side padding would
        // otherwise be added on top of it, making the section wider than the viewport.
        boxSizing: "border-box",
        background: "linear-gradient(90deg, #F54900 0%, #F0B100 100%)",
        padding: "clamp(64px, 14vw, 128px) 20px",
        display: "flex",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      <div style={{ maxWidth: "900px", width: "100%" }}>
        <img src={ready_beer} alt="ready to send beer" style={{ width: "80px", height: "80px" }} />

        <p
          style={{
            margin: 0,
            fontSize: "clamp(32px, 8vw, 60px)",
            lineHeight: 1.15,
            color: "#ffffff",
            fontWeight: 700,
          }}
        >
          Ready to Send a Beer?
        </p>

        <p
          style={{
            margin: "16px 0 38px",
            color: "rgba(255,255,255,0.92)",
            fontSize: "18px",
            lineHeight: 1.5,
          }}
        >
          Gift a cold one to friends at local spots - digitally, instantly,
          and with our app!
        </p>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "16px",
            flexWrap: "wrap",
          }}
        >
          {/* A plain <a>, deliberately — not a <button onClick={navigate}> and not a router <Link>.
              Both of those route around the document load, and the document load is the point: only
              a full load re-runs the redirect script in public/index.html, which beats the React
              bundle to the store. Routing client-side instead leaves the redirect to the useEffect
              in appRedirect.js, one render later — and that render is the desktop fallback markup
              flashing on a phone. Making this an anchor puts the tap on the same mechanism a
              scanned QR already uses [AC-APPDL-F7]. The href is also what lets it be
              middle-clicked or opened in a new tab, which a button never could. */}
          <a
            href="/app_redirect"
            style={{
              borderRadius: "999px",
              minWidth: "190px",
              height: "48px",
              padding: "0 28px",
              backgroundColor: "#ffffff",
              color: "#F54900",
              cursor: "pointer",
              fontWeight: 700,
              fontSize: "15px",
              boxShadow: "0 10px 24px rgba(0, 0, 0, 0.2)",
              // The button next to it is a real <button>, which centres its label and shrinks to
              // its content for free. An anchor does neither, so the box behaviour is restated
              // here to keep the two controls the same size and their labels on the same line.
              boxSizing: "border-box",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              textDecoration: "none",
            }}
          >
            Download the App
          </a>

          <button
            type="button"
            onClick={() => navigate("/admin-login")}
            style={{
              border: "2px solid rgba(255,255,255,0.9)",
              borderRadius: "999px",
              minWidth: "170px",
              height: "48px",
              padding: "0 24px",
              backgroundColor: "transparent",
              color: "#ffffff",
              cursor: "pointer",
              fontWeight: 700,
              fontSize: "15px",
            }}
          >
            Partner Login
          </button>
        </div>

        <div
          style={{
            marginTop: "40px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "12px",
          }}
        >
          {/* A white card, not a bare image: the section behind is an orange gradient, and the
              rounded card keeps the code's own white border from reading as a cut-out square. */}
          <div
            style={{
              background: "#ffffff",
              padding: `${QR_CARD_PADDING}px`,
              borderRadius: "16px",
              boxShadow: "0 10px 24px rgba(0, 0, 0, 0.2)",
              display: "flex",
            }}
          >
            <img
              src={appDownloadQr}
              // Alt text, not a decorative empty string: on a screen reader this is the only
              // announcement that a download path exists here at all.
              alt="Scan to download the my HOOM app"
              width={QR_SIZE}
              height={QR_SIZE}
              data-testid="app-download-qr"
              style={{ display: "block", width: `${QR_SIZE}px`, height: `${QR_SIZE}px` }}
            />
          </div>
          <p
            style={{
              margin: 0,
              color: "rgba(255,255,255,0.92)",
              fontSize: "14px",
              fontWeight: 600,
            }}
          >
            Scan to download the app
          </p>
        </div>
      </div>
    </section>
  );
}

export default ReadyToSend;
